import { render } from "./AddCession.vue?vue&type=template&id=73fc46b6&ts=true"
import script from "./AddCession.vue?vue&type=script&lang=ts"
export * from "./AddCession.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__